import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import EditIcon from 'assets/icons/edit-icon'
import AddDetailsEffectTab from '../PressureModal/AddDetailsEffectTab'

const ReviewPressureModal = ({
  isOpen,
  title,
  preselectedItems,
  threatItemId,
  onBack = () => {},
  onReviewed = () => {},
  onEdit = () => {}
}) => {
  useEffect(() => {
    if (!isOpen) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [isOpen])

  if (!isOpen) return null

  const overlayStyle = {
    position: 'fixed',
    top: 120,
    left: 0,
    right: 0,
    bottom: 72,
    zIndex: 9998
  }

  return (
    <>
      <div
        style={{
          ...overlayStyle,
          background: 'rgba(255,255,255,0.95)'
        }}
      />
      <div
        style={{
          ...overlayStyle,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          padding: '40px 24px 16px',
          overflow: 'auto',
          zIndex: 9999,
          boxSizing: 'border-box'
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '950px',
            maxHeight: '100%',
            background: '#fff',
            borderRadius: '8px',
            border: '1px solid rgba(32, 32, 32, 0.1)',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            boxSizing: 'border-box'
          }}
        >
          <div
            style={{
              position: 'sticky',
              top: 0,
              zIndex: 3,
              background: '#fff',
              borderBottom: '1px solid rgba(32, 32, 32, 0.1)',
              padding: '16px 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
              flexShrink: 0
            }}
          >
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: 'rgba(32, 32, 32, 0.9)' }}>
              {title}
            </h3>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexShrink: 0 }}>
              <Button type="secondary" height="40px" marginTop="0" onClick={onBack}>
                <FormattedMessage id="backToPressureBtnText" />
              </Button>
              <Button type="primary" height="40px" marginTop="0" onClick={onReviewed}>
                <FormattedMessage id="reviewed" defaultMessage="Reviewed" />
              </Button>
              <Button type="secondary" height="40px" marginTop="0" withIcon onClick={onEdit}>
                <EditIcon />
                <FormattedMessage id="edit" defaultMessage="Edit" />
              </Button>
            </div>
          </div>
          <div style={{ padding: '0 0 24px', overflowX: 'hidden', overflowY: 'auto', minHeight: 0, flex: 1, width: '100%', boxSizing: 'border-box' }}>
            <AddDetailsEffectTab
              preselectedItems={preselectedItems}
              setIncomingSelection={() => {}}
              setMainTab={() => {}}
              setEcosystemsCount={() => {}}
              threatItemId={threatItemId}
              isEditable={false}
              isReviewMode={true}
              onBackToPressure={onBack}
              onCancel={onBack}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ReviewPressureModal
